import { MapPin } from 'lucide-react';
import ComingSoon from './ComingSoon';

export default function MasterLocationsPIT() {
  return (
    <ComingSoon
      icon={MapPin}
      title="Locations PIT"
      description="Master admin location management and configuration"
    />
  );
}
